import { render, staticRenderFns } from "./customNumberInput.vue?vue&type=template&id=225e6fe0&scoped=true"
import script from "./customNumberInput.vue?vue&type=script&lang=js"
export * from "./customNumberInput.vue?vue&type=script&lang=js"
import style0 from "./customNumberInput.vue?vue&type=style&index=0&id=225e6fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e6fe0",
  null
  
)

export default component.exports